export default __webpack_public_path__ + "static/media/Icon=Unit Types.bb3fae73.svg";